<template>
  <v-card>
 <v-container>
        <div class="container-fluid">
            <h3>Change Password</h3>
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
            >
              <div class="row">
                  <div class="form-group col">
                    <v-text-field
                      v-model="form.old_password"
                      label="New Password"
                      required
                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="show1 ? 'text' : 'password'"
                      @click:append="show1 = !show1"
                    ></v-text-field>
                  </div>
              </div>
              <div class="row">
                  <div class="form-group col">
                    <v-text-field
                      v-model="form.new_password"
                      label="Confirm Password"
                      required
                      :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="show2 ? 'text' : 'password'"
                      @click:append="show2 = !show2"
                    ></v-text-field>
                  </div>
              </div>

              <v-btn
                :disabled="!valid"
                color="success"
                class="mr-4"
                @click="gantiPassword"
              >
                Submit
              </v-btn>
            
              <v-btn
                color="error"
                class="mr-4"
                @click="onClose"
              >
                Cancel
              </v-btn>
            
            </v-form>
        </div>
    </v-container>
  </v-card>
</template>

<script>
import axios from '@/axios'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
  export default {
    data: () => ({
      valid: true,
      name: '',
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      select: null,
      items: [
        'Item 1',
        'Item 2',
        'Item 3',
        'Item 4',
      ],
      checkbox: false,
      form:{},
      show1:false,
      show2:false
    }),

    methods: {
      validate () {
        this.$refs.form.validate()
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      onClose(){
          this.form = {}
          this.$emit('closeDialog');
      },
      gantiPassword(){
        let old_password = this.form.old_password
        let new_password = this.form.new_password

        if(old_password != new_password){
            Swal.fire({
                       title:'Peringatan',
                       icon :'warning',
                       text:'Password Baru Tidak Sama'
                   });
        }else{
            axios({
                      method: 'post',
                      url: 'gantipassword',
                      data: {
                        user_id : this.$session.get('user_id'),
                        new_password : this.form.new_password
                      },
                      headers: {
                        'Authorization': 'Bearer ' + this.$session.get('token'),
                      },
                  }).then(response => {
                       Swal.fire({
                                  title:'Peringatan',
                                  icon :'success',
                                  text:response.data.message
                              });
                      //this.printProfile(response.data.id,this.formData.na
                      this.form={}
                      this.$emit('closeDialog');
                      // console.log(JSON.stringify(response));
                      // this.users=response.data;
                  }).catch(error=>{
                      console.log('Error Fetch Data '+error);
                      // var status = error.response.status
                  });
        }
        // console.log(this.form);
        // alert(this.$session.get('user_id'));
      }
    },
  }
</script>